<script lang="ts" setup>
const props = defineProps({
  printable: { type: Boolean, default: false },
  backUrl: {
    type: String,
  },
  showActions: {
    type: Boolean,
    default: true,
  },
});

const hasHistory = computed(() => {
  if (process.server) return false;
  return window.history.state.position > 0;
});

const pseudoLoginStore = usePseudoLogin();
const { isPseudoLogin, pseudoId } = storeToRefs(pseudoLoginStore);

const onNavigateBack = () => {
  if (props.backUrl) {
    navigateTo(props.backUrl, { replace: true });
  } else {
    if (window.history.state.back == null) {
      navigateTo("/");
      return;
    }

    useRouter().back();
  }
};

const appUserStore = useAppUserDataStore();
const { isInitialized } = storeToRefs(appUserStore);
</script>

<template>
  <div class="h-screen" :class="{ 'print:h-auto': printable }">
    <BaseAppBar class="fixed" :class="{ 'print:hidden': printable }">
      <template #leading>
        <div class="h-full flex flex-row items-center">
          <slot name="app-bar-leading">
            <ClientOnly>
              <BaseIconButton
                v-if="hasHistory || backUrl"
                :size="40"
                @click="() => onNavigateBack()"
              >
                <BaseIconArrowLeft size="20" />
              </BaseIconButton>
            </ClientOnly>
          </slot>
          <div class="ml-2 text-h5">
            <slot name="app-bar-title" />
          </div>
        </div>
      </template>
      <template #actions v-if="showActions">
        <span v-if="isPseudoLogin" class="flex flex-row items-center mr-2">
          <span class="text-danger-default mr-2">Pseudoed</span>
          <BaseTextButton @click="pseudoLoginStore.setPseudoId(undefined)">
            Clear
          </BaseTextButton>
        </span>
        <HelpButton class="mr-2" />
        <ReportProblemButton :is-consolidated="true" />
        <slot name="app-bar-actions" />
      </template>
    </BaseAppBar>
    <div class="pt-[60px] h-full bg-surface" :class="{ 'print:h-auto print:bg-white print:pt-0': printable }">
      <ClientOnly>
        <div class="h-full" :class="{ 'print:h-auto': printable }" v-if="isInitialized">
          <slot />
        </div>
        <BaseLoading v-else class="h-full w-full" />
      </ClientOnly>
    </div>
  </div>
</template>

<style scoped></style>
